import { createGlobalState } from './createGlobalState';

const { useWithState, useDispatch, useState } = createGlobalState<boolean, boolean>((_, v) => v, true);

export function useSetNavbarVisibility() {
    return useDispatch();
}

export function useNavbarVisibility() {
    return useState();
}

export function useWithNavbarVisibility() {
    return useWithState();
}
